<!-- This component is very specific to New Tax Roll, so if this functionality
 is needed then we need to create a new component -->
<template>
  <v-container :key="reloadKey">
    <HandleImportError
      :dialog="dialog"
      :errorMode="errorMode"
      :errors="errors"
      @openCloseDialog="openCloseDialog"
      @getAdditionalImportedData="getAdditionalImportedData"
    />
      <v-file-input
      v-model="file"
      :accept="acceptedFormats"
      :label="'Import ' + acceptedFormats"
      show-size
      clearable
      @change="uploadImportFile"
      class="input-text-size ma-0 pa-0" />
      <div class="d-flex align-center justify-start flex-row flex-nowrap">
      <v-select
        v-model="selectedFileName"
        class="input-text-size ma-0 pa-0 uploaded-files-select"
        :items="fileList"
        label="Uploaded files list"
        item-text="fileName"
        item-value="fileName"/>
        <v-btn icon small color="blue darken-1" class="ma-0 pa-0 mt-n4 ml-2"
          title="Download the selected file"
          :loading="downloadLoading" :disabled="downloadLoading"
          @click="handleDownloadFileFromBackend">
          <v-icon small>{{ icons.mdiDownload }}</v-icon>
        </v-btn>
        <v-btn icon small color="red darken-1" class="ma-0 pa-0 mt-n4 ml-1"
          title="Delete the selected file"
          @click="handleDeleteFileInBackend">
          <v-icon small>{{ icons.mdiDelete }}</v-icon>
        </v-btn>
        </div>
      <!-- Only the data files above can be imported. Everything else that lands in the same
           staging folder is listed here so it can still be opened: the Abstract, Advance Tax
           and bill request error lists a conversion saves as they are printed, plus the
           escrow/composite PDFs that ship inside a Landmark archive. -->
      <div v-if="otherFileList.length"
        class="d-flex align-center justify-start flex-row flex-nowrap">
      <v-select
        v-model="selectedOtherFileName"
        class="input-text-size ma-0 pa-0 uploaded-files-select"
        :items="otherFileList"
        label="Saved reports and other files"/>
        <v-btn icon small color="blue darken-1" class="ma-0 pa-0 mt-n4 ml-2"
          title="Download the selected file"
          :loading="otherDownloadLoading" :disabled="otherDownloadLoading"
          @click="handleDownloadOtherFileFromBackend">
          <v-icon small>{{ icons.mdiDownload }}</v-icon>
        </v-btn>
        <v-btn icon small color="red darken-1" class="ma-0 pa-0 mt-n4 ml-1"
          title="Delete the selected file"
          @click="handleDeleteOtherFileInBackend">
          <v-icon small>{{ icons.mdiDelete }}</v-icon>
        </v-btn>
        </div>
        <v-row>
          <v-col :cols="isFireTaxSelected ? 6 : 12">
            <!-- item-disabled greys out the profiles that have no working parser behind them
            (see assesorList) - they stay visible, but cannot be picked and imported. -->
            <v-select :items="profileItem" class="input-text-size ma-0 pa-0"
            item-text="name" item-value="value" value="text" item-disabled="notSupported"
            :disabled="profileDisabled" :no-data-text="profileDisabledText"
            :label="profileName" v-model="selectedProfileName" @change="handleProfileChange" />
          </v-col>
          <v-col cols="6" v-if="isFireTaxSelected">
            <!-- TULSA SA - the district picked here is the only thing that puts the file's records
             in a special assessment district, so it offers the SA tax districts themselves (the
             same isSpecialAssessment list the SA CSV dialog below uses) rather than the fire x-ref
             names, and it is required. Left blank the backend used to fall back to the assessor's
             ad valorem code, which mis-districted all 10,266 records of the 2026 conversion. -->
            <CommonDropDowns v-if="isTulsaSaSelected" :isItTaxDistrict=true
            taxDistrictLabelOverride="Special Assessment District"
            :taxDistrictValue="selectedFireDistrict" :isItTaxDistrictRequired="true"
            taxDistrictFilterFieldsName="isSpecialAssessment"
            @change="handleFireDistrictChange" />
            <v-select v-else :items="assessorFireTaxXRefFilterList" class="input-text-size ma-0 pa-0"
            item-text="fireDistrict" item-value="fireDistrict" :rules="required"
            label="Fire District" v-model="selectedFireDistrict" />
          </v-col>
        </v-row>
    <div class="d-flex align-center justify-space-around flex-row
        taxroll-table-wrapper-two">
      <!-- <v-btn class="input-text-size ma-0 pa-0 mt-n4" text color="blue darken-1"
       @click="validateFile" :disabled="importing">
        Validate
      </v-btn> -->
      <v-btn class="input-text-size ma-0 pa-0 mt-n4" text color="blue darken-1"
       @click="preImportInBackend" :disabled="importing || isFireDistrictMissing">
        Import
      </v-btn>
      <v-checkbox label="Use Advanced Tax" class="input-text-size ma-0 pa-0"
       v-model="useAdvancedTaxFlag" @change="handleAdvancedTaxChange" />
      <!-- Blank adjusts every prepaid record, which is what Use Advanced Tax did on its own.
       A value limits the adjustment to the records whose calculated tax is within that many
       dollars of the prepaid amount; the rest keep the assessor's tax for manual review. -->
      <!-- :default-value="null" matters: the global v-currency-field config defaults it to 0,
       which would turn a cleared field into a $0 tolerance - the opposite of blank. -->
      <v-currency-field v-if="useAdvancedTaxFlag"
       class="input-text-size ma-0 pa-0 mt-n4 advance-tax-tolerance"
       label="Adjust if within $"
       hint="Blank adjusts every prepaid record"
       persistent-hint
       clearable
       :default-value="null"
       v-model="advanceTaxTolerance" />
      <!-- <v-btn class="input-text-size" text color="blue darken-1" @click="viewFile">
        View File
      </v-btn> -->
    </div>
    <v-row v-if="importing">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <p class="input-text-size">{{statusText}}</p>
          <v-progress-linear
          color="deep-purple accent-4"
          :value="progress"
          rounded
          height="5"
          ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-if="reload">
      <v-col cols="12">
        <v-btn class="input-text-size" rounded
          id="tmc-btn-import-state-reload-beta" @click="reloadMe">
          <v-icon class="mr-2">{{icons.mdiReload}}</v-icon> Load another
        </v-btn>
      </v-col>
      <v-col cols="12">
        <span class="input-text-size" v-if="showImportTimmings">Imported in: {{this.timing}}</span>
      </v-col>
    </v-row>
    <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey"
  dialogDynamicWidth="100vw"
  :canSave="false">
    <template v-slot:[`editedItem`]="{ }">
      <v-textarea id="edited-item-remarks"
          class="war-trans-item-remarks"
          rows="10"
          :value="dataFromImport"
          ></v-textarea>
    </template>
      </CRUDDialog>
    <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKeyForError"
      dialogDynamicWidth="50vw" :canSave="false">
    <template v-slot:[`editedItem`]="{ }">
      <p v-if="errorList.xRefListErrorList && errorList.xRefListErrorList.length">
        Code {{(errorList.xRefListErrorList || '').toString()}} was found in the import file
from the assessed, but this code does not exist in our cross-reference file. Be sure to the
tax district code to this new x-ref record created, and then import the file again.
      </p>
      <p v-if="errorList.countyErrorList && errorList.countyErrorList.length">
        The import file is for County Number {{(errorList.countyErrorList || '').toString()}}
which does not match the current environment. Please check and then try again
      </p>
      <p v-if="errorList.levyMillsErrorList && errorList.levyMillsErrorList.length">
        For Assr Code {{ errorList.levyMillsErrorList[0].assrCode }} the total levies are
{{ errorList.levyMillsErrorList[0].assrLevies }}.  For corresponding Tax District
{{ errorList.levyMillsErrorList[0].ourTaxDistrict }} the treasurer has levies of
{{ errorList.levyMillsErrorList[0].ourLevies }}.
      </p>
      <p v-if="errorList.grossAssessedErrorList && errorList.grossAssessedErrorList.length">
        Assessor gross assessed value {{ errorList.grossAssessedErrorList[0].grossAssessedValue }}
does not match sum of Land {{ errorList.grossAssessedErrorList[0].land }} Improvements
{{errorList.grossAssessedErrorList[0].improvements }} Mobile Home
{{ errorList.grossAssessedErrorList[0].mobileHome }}
and {{ errorList.grossAssessedErrorList[0].assessorPenalty }}.
      </p>
      <p v-if="errorList.netAssessedErrorList && errorList.netAssessedErrorList.length">
        Assessor net assessed value {{ errorList.netAssessedErrorList[0].netAssessedValue }}
does not match sum of Land {{ errorList.netAssessedErrorList[0].land }} Improvements
{{ errorList.netAssessedErrorList[0].improvements }} Mobile Home
{{ errorList.netAssessedErrorList[0].mobileHome }}
and {{ errorList.netAssessedErrorList[0].assessorPenalty }}
minus exemptions {{ errorList.netAssessedErrorList[0].exemptions }}.
      </p>
      <p v-if="errorList.taxCalculationErrorList && errorList.taxCalculationErrorList.length">
        Assessor total tax {{errorList.taxCalculationErrorList[0].taxAmount}} does not match
our calculated tax of {{errorList.taxCalculationErrorList[0].ourTaxAmount}}.
      </p>
      <p v-if="errorList.taxIdsNotFoundErrorList && errorList.taxIdsNotFoundErrorList.length">
        Some Tax ID's are not found in the new taxroll. These records will be skipped:
Tax ID {{ (errorList.taxIdsNotFoundErrorList || '').toString() }}
      </p>
      <p v-if="errorList.taxDistrictCodeNotFoundErrorList &&
       errorList.taxDistrictCodeNotFoundErrorList.length">
       Some Tax Districts are not found in the new taxroll.
Tax District {{ (errorList.taxDistrictCodeNotFoundErrorList || '').toString() }}
      </p>
    </template>
    <template v-slot:[`additionalActions`]>
      <v-btn class="input-text-size" text color="blue darken-1"
       :loading="importing" :disabled="importing"
       @click="preImportInBackend">
        Ignore Errors
      </v-btn>
    </template>
      </CRUDDialog>
    <CRUDDialog ref="crudDialogForSA" :baseCrudKey="baseCrudKeyForSpecialAssessment"
     dialogDynamicWidth="30vw" :canSave="false" :canCancel="false"
     onlyDialogHeaderName="SA Import - Information Needed">
      <template v-slot:[`editedItem`]="{ }">
        <CommonDropDowns :isItTaxDistrict=true
          @change="dataFromCommonDropDowns" taxDistrictLabelOverride="Tax District for SA records"
          :taxDistrictValue="saDialogData.taxDistrict" :isItTaxDistrictRequired="true"
          taxDistrictFilterFieldsName="isSpecialAssessment" />
        <v-text-field class="input-text-size" label="TID Range (to be added to base TID)"
          v-model="saDialogData.baseTaxId" :rules="required" type="number" />
        <!-- The SA record is copied from the parcel's real estate record, situs included, so a
         parcel with a situs address shows that address in Tax Inquiry's Desc/Situs instead of
         the tax district. Blanking the situs is what makes the district show (Kay/Duck Creek). -->
        <v-checkbox class="input-text-size ma-0 pa-0" label="Leave situs address blank"
          v-model="saDialogData.blankSitus" />
      </template>
      <template v-slot:[`additionalActions`]>
      <v-btn class="input-text-size" text color="blue darken-1"
       :loading="importing" :disabled="importing"
       @click="(e) => preImportInBackend(e, 'saDialogImport')">
        Import
      </v-btn>
      <v-btn class="input-text-size" text color="blue darken-1"
       @click="closeSpecialAssessmentDialog">
        Cancel
      </v-btn>
    </template>
    </CRUDDialog>
  </v-container>
</template>

<script>
import {
  mdiDelete,
  mdiDownload,
  mdiReload,
} from '@mdi/js';
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { clients } from '../../../util/clients';
import {
  sanitizeFilename,
} from '../../../util/shared/vue-global';
import HandleImportError from '../../../views/bulk/HandleImportError.vue';
import CRUDDialog from '../base/crud-2.0/CRUDDialog.vue';
import CommonDropDowns from '../../tax/common-utils/CommonDropDowns.mixin.vue';
import '../../../assets/style.css';

const { backendRest } = clients.direct;

const initdata = () => ({
  form: new FormData(),
  dialog: false,
  errorMode: undefined,
  icons: {
    mdiDelete,
    mdiDownload,
    mdiReload,
  },
  downloadLoading: false,
  otherDownloadLoading: false,
  file: undefined,
  importing: false,
  // A single failed poll is a blip; three in a row means the run is out of reach and the
  // screen must say so rather than quietly clearing itself.
  consecutivePollFailures: 0,
  reload: false,
  reloadKey: 0,
  statusText: '',
  progress: 0,
  timing: undefined,
  errors: [],
  errorList: {},
  chunkID: '',
  additionalImportedData: {},
  programSelect: undefined,
  baseCrudKey: 'commonImportShowFile',
  baseCrudKeyForError: 'commonImportShowError',
  baseCrudKeyForSpecialAssessment: 'importShowSpecialAssessment',
  dataFromImport: null,
  statusPolling: null,
  selectedFileName: '',
  selectedOtherFileName: '',
  selectedProfileName: '',
  selectedFireDistrict: '',
  useAdvancedTaxFlag: false,
  advanceTaxTolerance: null,
  isFireTaxSelected: false,
  saDialogData: {
    taxDistrict: '',
    baseTaxId: null,
    blankSitus: false,
  },
});

export default {
  name: 'UploadToBackend',
  components: {
    HandleImportError,
    CRUDDialog,
    CommonDropDowns,
  },
  data: () => initdata(),
  props: {
    acceptedFormats: {
      type: String,
      default: '.txt,.csv,.prn',
    },
    profileName: {
      type: String,
      default: '',
    },
    showImportTimmings: {
      type: Boolean,
      default: true,
    },
    folderName: {
      type: String,
      default: '',
    },
    profileItem: {
      type: Array,
      default: () => [],
    },
    /* New Tax Roll filters the profile list by the Assessor Company chosen above it, and holds
       this dropdown shut until that choice is made. Defaults to false so every other caller
       keeps the plain always-open dropdown. */
    profileDisabled: {
      type: Boolean,
      default: false,
    },
    profileDisabledText: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      fileList: (state) => state.tax.commonImport.fileList,
      otherFileList: (state) => state.tax.commonImport.otherFileList || [],
      assessorFireTaxXRefDropDown: (state) => state.base.crud.items.assessorFireTaxXRefDropDown,
    }),
    required() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    assessorFireTaxXRefFilterList() {
      const { assessorFireTaxXRefDropDown } = this;
      if (this.isTulsaSaSelected) {
        // if its for tulsa, we need to check if the record has the isItSaForTulsa flag set to true
        return assessorFireTaxXRefDropDown.filter((item) => item.isItSaForTulsa);
      }
      return assessorFireTaxXRefDropDown || [];
    },
    isTulsaSaSelected() {
      return (this.selectedProfileName || '').includes('Assessor Tulsa Special Assessment File Import');
    },
    /* Both profiles that show the district dropdown need a value before anything is sent - the
       district is not recoverable from the file, and neither import can tell a wrong one from a
       right one afterwards. */
    isFireDistrictMissing() {
      return this.isFireTaxSelected && !this.selectedFireDistrict;
    },
  },
  watch: {
    /* The offered profiles change when the Assessor Company above is changed. A profile picked
       under the old company must not survive that - left selected it is still what Import
       sends, so a Tulsa county could import through Landmark's parser without the dropdown
       ever showing the name of the profile that ran. */
    profileItem(offered) {
      const stillOffered = (offered || []).some((p) => p.value === this.selectedProfileName);
      if (stillOffered) return;
      this.selectedProfileName = '';
      this.isFireTaxSelected = false;
      this.selectedFireDistrict = '';
    },
  },
  created() {
    this.getFileListMethod();
  },
  mounted() {
    this.getFileListMethod();
  },
  methods: {
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('jobs', [
      'backup',
    ]),
    ...mapMutations('jobs', [
      'setPrefix',
      'setGroup',
      'setCollection',
    ]),
    ...mapActions([
      'flashError',
      'flashSuccess',
      'flashWarn',
    ]),
    ...mapMutations('base/crud', [
      'setIsVisible',
    ]),
    ...mapActions('tax/commonImport', [
      'uploadFileToDB',
      'pollingToGetBackgroundProcess',
      'getFileListBasedOnFolderName',
      // 'validateFileBeforeImportToDB',
      // 'pollingToGetNewTaxrollErrorList',
      'deleteFileInBackend',
      'downloadFileFromBackend',
    ]),
    handleDialog() {
      this.setIsVisible([this.baseCrudKey, true]);
    },
    getAdditionalImportedData(val) {
      this.additionalImportedData = { ...val };
    },
    openCloseDialog(value) {
      this.dialog = value;
    },
    dataFromCommonDropDowns(val, whichField) {
      this.saDialogData[whichField] = val;
    },
    viewFile() {
      const { file } = this;
      if (file) {
        const bytesVal = 1000000; // its equal to 1mb
        const chunkSize = 2000;
        const fileSize = (file.size > bytesVal) ? bytesVal : file.size;
        const dataVal = [];
        for (let i = 0; i < fileSize; i += chunkSize) {
          // eslint-disable-next-line func-names
          (function (fil, start) {
            const reader = new FileReader();
            const blob = fil.slice(start, chunkSize + start);
            reader.readAsText(blob);
            reader.addEventListener(
              'load',
              () => {
                dataVal.push(reader.result);
              },
              false,
            );
          }(file, i));
        }
        this.dataFromImport = dataVal;
        this.handleDialog();
      }
    },
    startTheCounter(folderName) {
      this.statusPolling = setInterval(() => {
        this.callThePollingFunc(folderName);
      }, 2200);
    },
    stopPolling() {
      this.importing = false;
      this.statusText = '';
      clearInterval(this.statusPolling);
      this.consecutivePollFailures = 0;
    },
    /* Every way this can end now says so. Previously an empty status, an unrecognised status
       or a failed poll all took the same silent exit - polling stopped, the status line was
       cleared, and two of the three went on to emit loadCRUDList as though the import had
       finished. That is what made a run that had actually failed look complete. */
    failPolling(message) {
      this.stopPolling();
      this.flashError(message);
    },
    callThePollingFunc(folderName) {
      const loadPromise = this.pollingToGetBackgroundProcess({ folderName });
      loadPromise.then((res) => {
        const status = res && res.status;

        // A blip between polls should not kill a running import, but a backend that stays
        // unreachable must not be mistaken for one that finished.
        if (status === 'unreachable') {
          this.consecutivePollFailures += 1;
          if (this.consecutivePollFailures >= 3) {
            this.failPolling('Lost contact with the server while importing. The import may still be running - reopen this screen to check.');
          }
          return;
        }
        this.consecutivePollFailures = 0;

        if (status === 'File imported!') {
          // Only now is the run known to be complete AND whole: the backend has already
          // reconciled what the file held against what the database wrote, in the terms that
          // apply to this kind of file, and fails the run if they do not agree.
          this.statusText = '';
          // A file that updates the staged roll (MH, fire tax) adds no rows, so it reports
          // what it matched instead of what it staged.
          const written = res.matched === null || res.matched === undefined
            ? `${res.staged === null || res.staged === undefined ? '' : ` (${res.staged} staged)`}`
            : ` (${res.matched} staged records updated)`;
          this.flashSuccess(`File imported - ${res.inserted || 0} of ${res.linesRead || 0} records${written}`);
          /* Shown separately and left on screen, because the import SUCCEEDED and this is
             still something the operator has to look at - the lines of their file that the
             staged roll had nothing to match. */
          (res.warnings || []).forEach((warning) => this.flashWarn(warning));
          this.stopPolling();
          this.$emit('loadCRUDList');
          return;
        }

        if (status === 'Import failed') {
          const where = res.failedBatch ? ` at batch ${res.failedBatch}` : '';
          const got = `${res.inserted || 0} of ${res.linesRead || 0} records were imported before it stopped`;
          this.failPolling(`Import failed${where}: ${res.error || 'unknown error'}. ${got}. The staged data is incomplete - do not build the abstract from it.`);
          return;
        }

        if (!status) {
          this.failPolling('The import is no longer running and reported no result. Re-run it and check the staged record count.');
          return;
        }

        if (status !== 'Starting the import process' && status !== 'importing file to DB') {
          this.failPolling(`Import stopped with an unexpected status: ${status}`);
          return;
        }

        this.statusText = `Currently imported ${(res && res.count) || 0} records`;
      }).catch((err) => {
        console.error('--------error', err);
        this.failPolling('There was a problem checking the import status. The import may still be running - reopen this screen to check.');
      });
    },
    // startTheCounterForValidateFile() {
    //   this.statusPolling = setInterval(() => {
    //     this.callThePollingFuncForValidateFile();
    //   }, 2200);
    // },
    // callThePollingFuncForValidateFile() {
    //   const loadPromise = this.pollingToGetNewTaxrollErrorList({ folderName: this.folderName });
    //   loadPromise.then((res) => {
    //     this.statusText = res.errorList;
    //     // 0 for initial value, 201 for error, 200 for no error, 202 for validating
    //     if (res.errorList.statusCode === 200) {
    //       this.flashSuccess('File validated successfully');
    //       this.importing = false;
    //       this.statusText = '';
    //       clearInterval(this.statusPolling);
    //     } else if (res.errorList.statusCode === 201) {
    //       this.importing = false;
    //       this.statusText = '';
    //       clearInterval(this.statusPolling);
    //       this.errorList = res.errorList;
    //       this.setIsVisible([this.baseCrudKeyForError, true]);
    //     } else if (res.errorList.statusCode === 202) {
    //       this.statusText = 'File is being validated...';
    //     }
    //   }).catch((err) => {
    //     console.error('--------error', err);
    //     this.importing = false;
    //     this.statusText = '';
    //     clearInterval(this.statusPolling);
    //   });
    // },
    preImportInBackend(e, fromWhere = '') {
      // Import, Ignore Errors and the SA Import all land here; each starts a whole import run,
      // so nothing may start one while an upload or a run is already underway.
      if (this.importing) return;
      if (!this.selectedFileName || !this.selectedProfileName) {
        this.flashWarn('Please select a file and profile');
        return;
      }
      /* Not only on the Import button - Ignore Errors on the validation dialog comes back through
         here too, and that path would otherwise start an import the disabled button refused. */
      if (this.isFireDistrictMissing) {
        this.flashWarn(this.isTulsaSaSelected
          ? 'Pick the Special Assessment district this file belongs to.'
          : 'Pick the Fire District this file belongs to.');
        return;
      }
      let fireDistrictName = '';
      if (this.isTulsaSaSelected) {
        // this is for tulsa
        fireDistrictName = this.selectedFireDistrict;
      }

      const criteria = {
        folderName: this.folderName,
        profileName: this.selectedProfileName,
        fileName: this.selectedFileName,
        additionalInputs: {
          useAdvancedTaxFlag: this.useAdvancedTaxFlag,
          // Only meaningful alongside the flag, and only when the user entered something -
          // null leaves the backend adjusting every prepaid record.
          advanceTaxTolerance: this.useAdvancedTaxFlag && this.advanceTaxTolerance !== ''
            ? this.advanceTaxTolerance
            : null,
          fireDistrictName,
        },
      };

      this.setIsVisible([this.baseCrudKeyForError, false]);

      // if its a Special Assessment CSV, we need show the SA dialog
      if (!fromWhere && this.selectedProfileName.includes('Assessor Special Assessment CSV')) {
        this.setIsVisible([this.baseCrudKeyForSpecialAssessment, true]);
        return;
      }

      // this block is executed when there is SA import only
      if (fromWhere === 'saDialogImport') {
        const isValidForm = this.$refs.crudDialogForSA.validateForm();
        if (isValidForm) {
          criteria.additionalInputs = {
            baseTaxId: this.saDialogData.baseTaxId,
            taxDistrict: this.saDialogData.taxDistrict,
            blankSitus: this.saDialogData.blankSitus,
          };
          this.importInBackend(criteria);
          this.closeSpecialAssessmentDialog();
        }
        return;
      }

      // this is for rest of the imports
      this.importInBackend(criteria);
    },
    closeSpecialAssessmentDialog() {
      this.setIsVisible([this.baseCrudKeyForSpecialAssessment, false]);
    },
    handleAdvancedTaxChange(val) {
      // The field is hidden when the box is cleared, so anything typed into it is dropped too -
      // otherwise an invisible tolerance would still be sent on the next import.
      if (!val) this.advanceTaxTolerance = null;
    },
    handleProfileChange(val) {
      if (val.includes('Assessor Fire Tax File Import')) this.isFireTaxSelected = true;
      else if (val.includes('Assessor Tulsa Special Assessment File Import')) this.isFireTaxSelected = true;
      else this.isFireTaxSelected = false;
      // The two dropdowns offer different lists, so a district picked under the previous profile
      // is not a valid answer for this one - and the Tulsa SA import cannot correct a wrong one.
      this.selectedFireDistrict = '';
    },
    handleFireDistrictChange(val) {
      this.selectedFireDistrict = val || '';
    },
    /* Every way an import can be started lands here - the Import button, Ignore Errors on the
       validation dialog, and the SA dialog's own Import - so this is the one place that has to
       tell the parent a new run is underway. From here on the totals on screen belong to a run
       that is being replaced, so they are cleared before anything is sent. */
    importInBackend(criteria = {}) {
      this.$emit('importStarted');
      const loadTaxPromise = this.uploadFileToDB(criteria);
      this.importing = true;
      this.consecutivePollFailures = 0;
      loadTaxPromise.then((started) => {
        /* Only poll a run that actually started. A refused start - the backend already has a
           live run for this folder - returns false, having flashed the reason; polling it
           would attach this screen to somebody else's import and report their result here. */
        if (!started) {
          this.importing = false;
          this.statusText = '';
          return;
        }
        this.startTheCounter(this.folderName);
      });
    },
    // validateFile() {
    //   if (!this.selectedFileName || !this.selectedProfileName) {
    //     this.flashWarn('Please select a file and profile');
    //     return;
    //   }
    //   const criteria = {
    //     folderName: this.folderName,
    //     profileName: this.selectedProfileName,
    //     fileName: this.selectedFileName,
    //     additionalInputs: {
    //       useAdvancedTaxFlag: this.useAdvancedTaxFlag,
    //     },
    //   };
    //   const loadTaxPromise = this.validateFileBeforeImportToDB(criteria);
    //   this.importing = true;
    //   loadTaxPromise.then(() => {
    //     this.startTheCounterForValidateFile(this.folderName);
    //   });
    // },
    async uploadImportFile(inputFile) {
      this.timing = new Date();
      this.importing = true;
      this.statusText = 'Loading file...';
      const form = new FormData();
      form.append('fileName', sanitizeFilename(inputFile.name));
      form.append('data', inputFile);
      form.append('fileSize', inputFile.size);
      try {
        const formHeaders = {
          'Content-Type': 'multipart/form-data',
        };
        const results = await backendRest.post(`/importFiles/upload/${this.folderName}`, form, {
          headers: formHeaders,
          onUploadProgress: (progEvt) => {
            console.info('upload');
            const percentComplete = (progEvt.loaded / progEvt.total) * 100;
            this.statusText = `${percentComplete}% of file uploaded...`;
          },
          timeout: 900000, // 15 minutes in milliseconds
        });
        if (results.data.status === 'success') {
          this.statusText = 'file uploaded';
        }
      } catch (error) {
        console.error('--------error', error);
      } finally {
        await this.getFileListMethod();
        this.importing = false;
        this.statusText = '';
      }
    },
    /* Public in practice - the parent screen calls this through a ref after unzipping
       a Landmark archive, which expands into this same folder, so the newly extracted
       files have to show up here. */
    async getFileListMethod() {
      await this.getFileListBasedOnFolderName({ folderName: this.folderName });
    },
    async handleDownloadFileFromBackend() {
      if (!this.selectedFileName) {
        this.flashWarn('Please select a file to download.');
        return;
      }
      this.downloadLoading = true;
      try {
        await this.downloadFileFromBackend({
          folderName: this.folderName,
          fileName: this.selectedFileName,
        });
      } finally {
        this.downloadLoading = false;
      }
    },
    async handleDeleteFileInBackend() {
      if (!this.selectedFileName) {
        this.flashWarn('Please select a file and profile');
        return;
      }
      await this.deleteFileInBackend({
        folderName: this.folderName,
        fileName: this.selectedFileName,
      });
      // the selection just stopped existing, so clear it rather than leaving a name
      // in the box that Import would then fail to find
      this.selectedFileName = '';
      this.getFileListMethod();
    },
    async handleDownloadOtherFileFromBackend() {
      if (!this.selectedOtherFileName) {
        this.flashWarn('Please select a file to download.');
        return;
      }
      this.otherDownloadLoading = true;
      try {
        await this.downloadFileFromBackend({
          folderName: this.folderName,
          fileName: this.selectedOtherFileName,
        });
      } finally {
        this.otherDownloadLoading = false;
      }
    },
    async handleDeleteOtherFileInBackend() {
      if (!this.selectedOtherFileName) {
        this.flashWarn('Please select a file to delete.');
        return;
      }
      await this.deleteFileInBackend({
        folderName: this.folderName,
        fileName: this.selectedOtherFileName,
      });
      this.selectedOtherFileName = '';
      this.getFileListMethod();
    },
    reloadMe() {
      Object.assign(this.$data, initdata());
      this.reloadKey += 1;
    },
  },
};
</script>

<style scoped>
/* Extracted Landmark files carry the archive name as a prefix
   (Adair_2025Taxroll111725_Adair2025EscrowedTaxReport.pdf), long enough to stretch
   the select and shove the download/delete icons around as the selection changes.
   The name is truncated to one line instead; it is still readable in full in the
   open menu. */
.uploaded-files-select {
  flex: 0 0 320px;
  max-width: 320px;
}

/* Vuetify's selections container is a wrapping flex row - left alone, a long name
   breaks onto a second line and grows the whole field's height. Forcing nowrap is
   what keeps the row one line tall; the min-width:0 below it is what actually lets
   the text ellipsize, since a flex item will not shrink past its content width
   without it. */
.uploaded-files-select >>> .v-select__selections {
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
}
.uploaded-files-select >>> .v-select__selection {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* the hidden input Vuetify keeps for keyboard input otherwise claims its own
   default width and pushes the name back out */
.uploaded-files-select >>> .v-select__selections input {
  min-width: 0;
  width: 0;
  flex: 0 1 auto;
}
</style>
